module.exports = __webpack_public_path__ + "media/images/history/kojdecky1-e5396af1e5fac7d050740b9a03fd6ce8.jpg";